import { useTranslation } from "react-i18next"
import LostPasswordForm from "features/lostPassword/lostPasswordForm"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import PageTitle from "features/navigation/pageTitle"

const LostPasswordPage = () => {

    const { t } = useTranslation()

    return (
        <>
            <PageTitle title={t('titleLostPassword')} />
            <Section>
                <LostPasswordForm />
            </Section>
        </>
    )
}

export default LostPasswordPage

